    import './DeleteAccount.scss';
    import React, { useState, useEffect, useRef } from 'react';
    import Button from '@mui/material/Button';
    import { useSelector, useDispatch } from 'react-redux';
    import { useNavigate } from 'react-router-dom';
    import { setIsLoggedIn, setIsAdmin, setUserInfo } from '../../reduxToolkit/redux';
    import fnc from '../mymod/commFunction';
    import { FaExclamationTriangle, FaMobileAlt, FaArrowLeft } from 'react-icons/fa';

    function DeleteAccount() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.appReducer.userInfo);

    const [step, setStep] = useState(1);        // 1: 비밀번호 확인, 2: 인증코드 입력
    const [password, setPassword] = useState('');
    const [confirmed, setConfirmed] = useState(false);
    const [verifyCode, setVerifyCode] = useState('');
    const [maskedHp, setMaskedHp] = useState('');
    const [timeLeft, setTimeLeft] = useState(0);
    const timerRef = useRef(null);

    useEffect(() => {
        return () => { if (timerRef.current) clearInterval(timerRef.current); };
    }, []);

    const startTimer = () => {
        setTimeLeft(300);
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
            if (prev <= 1) { clearInterval(timerRef.current); return 0; }
            return prev - 1;
        });
        }, 1000);
    };

    const formatTime = (sec) => {
        const m = Math.floor(sec / 60);
        const s = sec % 60;
        return `${m}:${String(s).padStart(2, '0')}`;
    };

    const handleSendCode = (e) => {
        e.preventDefault();
        if (!confirmed) {
        alert('계정 삭제 동의 체크박스를 체크해주세요.');
        return;
        }
        if (!password) {
        alert('비밀번호를 입력해주세요.');
        return;
        }
        if (!window.confirm('정말로 계정을 삭제하시겠습니까?\n인증번호가 등록된 번호로 발송되며, 인증 완료 시 즉시 삭제됩니다.')) {
        return;
        }
        fnc.sendAxios('/accountRoutes/sendDeleteCode', {
        id: userInfo.userId,
        pw: password,
        }, (res) => {
        if (res.error) {
            alert(res.message || '오류가 발생했습니다.');
            return;
        }
        setMaskedHp(res.maskedHp || '');
        startTimer();
        setStep(2);
        });
    };

    const handleDelete = (e) => {
        e.preventDefault();
        if (!verifyCode) {
        alert('인증번호를 입력해주세요.');
        return;
        }
        fnc.sendAxios('/accountRoutes/deleteAccount', {
        id: userInfo.userId,
        code: verifyCode,
        }, (res) => {
        if (res.error) {
            alert(res.message || '계정 삭제에 실패했습니다.');
            return;
        }
        alert('계정이 삭제되었습니다. 이용해 주셔서 감사합니다.');
        dispatch(setIsLoggedIn(false));
        dispatch(setIsAdmin(false));
        dispatch(setUserInfo({}));
        navigate('/');
        });
    };

    return (
        <div className='DeleteAccount'>
        <p className='section-title'>계정 삭제</p>

        <div className='warning-box'>
            <p><FaExclamationTriangle style={{ marginRight: '0.4em', verticalAlign: 'middle' }} /> 계정 삭제 시 이름·연락처·이메일 등 개인정보가 즉시 파기됩니다.</p>
            <p>삭제된 계정과 개인정보는 복구할 수 없습니다.</p>
        </div>

        {step === 1 && (
            <form onSubmit={handleSendCode}>
            <div className='field-block'>
                <label>*비밀번호 확인</label>
                <input
                type='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder='현재 비밀번호를 입력하세요'
                />
            </div>

            <div className='checkbox-wrap'>
                <input
                type='checkbox'
                id='confirm-delete'
                checked={confirmed}
                onChange={(e) => setConfirmed(e.target.checked)}
                />
                <label htmlFor='confirm-delete'>
                위 내용을 확인하였으며, 계정 삭제에 동의합니다.
                </label>
            </div>

            <Button variant='contained' color='error' className='btn-delete' type='submit'>
                인증번호 발송
            </Button>
            </form>
        )}

        {step === 2 && (
            <form onSubmit={handleDelete}>
            {maskedHp && (
                <p className='sent-notice'>
                <FaMobileAlt style={{ marginRight: '0.4em', verticalAlign: 'middle' }} /> {maskedHp}로 인증번호가 전송되었습니다.
                </p>
            )}

            <div className='field-block'>
                <label>*인증번호</label>
                <div className='code-wrap'>
                <input
                    type='text'
                    value={verifyCode}
                    onChange={(e) => setVerifyCode(e.target.value)}
                    placeholder='인증번호 6자리'
                    maxLength={6}
                    className='code-input'
                />
                {timeLeft > 0 && (
                    <span className={`timer-badge${timeLeft <= 60 ? ' urgent' : ''}`}>
                    {formatTime(timeLeft)}
                    </span>
                )}
                </div>
            </div>

            <Button variant='contained' color='error' className='btn-delete' type='submit'>
                계정 삭제
            </Button>

            <p className='resend-link'>
                <button type='button' onClick={() => { setStep(1); setVerifyCode(''); }}>
                <FaArrowLeft style={{ marginRight: '0.3em', verticalAlign: 'middle' }} /> 다시 입력
                </button>
            </p>
            </form>
        )}
        </div>
    );
    }

    export default DeleteAccount;
